import { 
    SLOW_AND_STEADY_T_SHIRT, 
    MN_PIN,
    SOCKS,  
    Product
} from '../products';

const littleGuysRecos: Product[] = [
    SLOW_AND_STEADY_T_SHIRT,
    MN_PIN,
    SOCKS,   
];

export default littleGuysRecos;